import { render, staticRenderFns } from "./want-to-back.vue?vue&type=template&id=0306ce5f&scoped=true"
import script from "./want-to-back.vue?vue&type=script&lang=js"
export * from "./want-to-back.vue?vue&type=script&lang=js"
import style0 from "./want-to-back.vue?vue&type=style&index=0&id=0306ce5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0306ce5f",
  null
  
)

export default component.exports